import { RefObject } from 'react'
import { TrackEvent } from '../../utils/trackingHelpers'

const videoPercentageSteps = [10, 25, 50, 75]
export type VideoTrackingProps = {
  video_title: string
  video_url: string
  video_duration: number
  video_provider: string
  video_percentage?: string
}

/**
 * Event triggering when video is started.
 */
export function videoStartEvent(
  videoRef: RefObject<HTMLVideoElement>,
  videoTrackingProps: VideoTrackingProps,
) {
  if (!videoRef.current) {
    return
  }

  TrackEvent('video_start', videoTrackingProps)
}

/**
 * Event triggering when video is progessing.
 */
export function videoProgressEvent(
  videoRef: RefObject<HTMLVideoElement>,
  videoTrackingProps: VideoTrackingProps,
) {
  if (!videoRef.current || videoRef.current.paused) {
    return
  }

  const currentTime = videoRef.current.currentTime
  const duration = videoRef.current.duration
  const videoProgress = (duration / 100) * videoPercentageSteps[0]
  const eventTriggerMoment =
    Math.round(currentTime) === Math.round(videoProgress)

  if (eventTriggerMoment) {
    TrackEvent('video_progress', {
      ...videoTrackingProps,
      video_percentage: videoPercentageSteps[0],
    })

    videoPercentageSteps.splice(0, 1)
  }
}

/**
 * Event triggering when video is ended.
 */
export function videoCompleteEvent(
  videoRef: RefObject<HTMLVideoElement>,
  videoTrackingProps: VideoTrackingProps,
) {
  if (!videoRef.current || !videoRef.current.ended) {
    return
  }

  TrackEvent('video_complete', {
    ...videoTrackingProps,
    video_percentage: 100,
  })
}
